import React, { useEffect } from "react";

import { useAlert } from "../../contexts/AlertContext";
import { useLoading } from "../../contexts/LoadingContext";
import { eventEmitter } from "../../events/eventEmitter";
import { Event, RequestErrorEvent, RequestSuccessEvent } from "../../events/events";

const METHOD_TO_ACTION_MAP: { [key: string]: string } = {
  POST: "created",
  PUT: "updated",
  DELETE: "deleted",
};

const EventListener: React.FC = () => {
  const { loading } = useLoading();
  const { alert } = useAlert();

  useEffect(() => {
    const handleRequestError = (event: RequestErrorEvent) => alert.error(event.error.message);
    const handleRequestSuccess = (event: RequestSuccessEvent) => {
      if (event.message) {
        alert.success(event.message);
        return;
      }

      const action = METHOD_TO_ACTION_MAP[event.method];
      if (action) alert.success(`Successfully ${action} the record`);
    };

    eventEmitter.on(Event.BackendRequestStart, loading.show);
    eventEmitter.on(Event.BackendRequestEnd, loading.hide);
    eventEmitter.on(Event.BackendRequestSuccess, handleRequestSuccess);
    eventEmitter.on(Event.BackendRequestError, handleRequestError);

    return () => {
      eventEmitter.off(Event.BackendRequestStart, loading.show);
      eventEmitter.off(Event.BackendRequestEnd, loading.hide);
      eventEmitter.off(Event.BackendRequestSuccess, handleRequestSuccess);
      eventEmitter.off(Event.BackendRequestError, handleRequestError);
    };
  }, [loading, alert]);

  return <></>;
};

export default EventListener;
